import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import { useState } from "react";
import { timelineOppositeContentClasses } from "@mui/lab/TimelineOppositeContent";
import LogItem from "./LogItem";
import { getlogData, getoldData } from "../../utils/ApiCalls/Logs";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { Pagination } from "antd";
import SearchField from "../SearchField";
import { getAllLocations } from "../../utils/ApiCalls/Locations";
import CustomizedTable from "../UI/CustomizedTable";
import moment from "moment";
import { downloadFile } from "../../utils/ApiCalls/Document";

const OldLogs = ({ type, refreshlog, slug, hidetitle }) => {
  const [pageSize, setPageSize] = useState(10);
  const [, dispatch] = useDataLayerValue();
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");
  const [rows, setRows] = React.useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [locationOption, setLocationOption] = useState([]);
  React.useEffect(() => {
    getData(page);
  }, [page, refreshlog, pageSize]);

  React.useEffect(() => {
    getLocation();
  }, []);

  const getLocation = async () => {
    let data = await getAllLocations();
    setLocationOption(data?.data || []);
  };
  const getData = async (value, sort, order) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let args = { type: type, page: value, limit: pageSize, search };
    if (order) {
      if (sort) {
        args = { ...args, sort };
      }
      args = { ...args, order };
    }

    let data = await getoldData(args);
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  async function downloadFileURL(url, filename) {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    await downloadFile(url);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  }
  const onSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };
  const columns = [
    {
      title: "Sl",
      width: 10,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },

    {
      title: "Created at",
      dataIndex: "uploaded_at",
      key: "uploaded_at",
      width: 200,
      render: (item) => moment(item).format("DD-MM-YYYY hh:mm a"),
    },
    {
      title: "Action",
      key: "operation",
      width: 100,
      render: (text, record) => (
        <>
          <div className="table_action_btn">
            <div
              onClick={() => downloadFileURL(`${record?.file_name}`)}
              className="btn success_btn"
            >
              <i className="fa fa-download" data-toggle="tooltip"></i>
            </div>
          </div>
        </>
      ),
    },
  ];
  const onChange = (pageNumber) => {
    setPage(pageNumber);
    setRows([]);
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header two_item">
          <h5 className="card-title">Old Logs</h5>
        </div>
        <div className="card-body">
          <CustomizedTable
            setRows={setRows}
            setPageSize={setPageSize}
            setPage={setPage}
            pageSize={pageSize}
            page={page}
            count={count}
            columns={columns}
            rows={rows}
            title={"User logs"}
          />
         
        </div>
      </div>
    </div>
  );
};

export default OldLogs;
